export enum TimePeriodEnum {
  week = 'week',
  allTime = 'all-time',
  current = 'current',
}
